import { render, staticRenderFns } from "./CustomCheckbox.vue?vue&type=template&id=5f107d2a&"
import script from "./CustomCheckbox.vue?vue&type=script&lang=js&"
export * from "./CustomCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports